module.exports = __webpack_public_path__ + "static/media/Irib_Iran.bf58a974.png";